import { FETCH_LOG_EVENTS_FOR_HISTORY_ENROLLMENT_UE, LOG_EVENTS_FOR_HISTORY_ENROLLMENT_UE_FIELDNAME } from 'automation-ui-log-events/api-client/queries/LogEventQueries';
import { useQuery } from 'data-fetching-client';
import { useMemo } from 'react';
import { FLOW_BY_REVISION_TIMESTAMP_FIELD_NAME, GET_FLOW_BY_REVISION_TIMESTAMP } from 'automation-ui-canvas/containers/enrollment-history/utils/flowByRevisionQueries';
export const useGetSelectedEnrollmentDetails = ({
  enrollmentId,
  flowId
}) => {
  var _sortedLogEvents$;
  const {
    data: {
      [LOG_EVENTS_FOR_HISTORY_ENROLLMENT_UE_FIELDNAME]: logEvents = []
    } = {},
    error: logEventsError,
    loading: areLogEventsLoading,
    refetch: refetchLogEvents,
    startPolling,
    stopPolling
  } = useQuery(FETCH_LOG_EVENTS_FOR_HISTORY_ENROLLMENT_UE, {
    variables: {
      enrollmentId,
      flowId,
      isHybrid: false
    },
    onCompleted: () => {}
  });

  // This is to display log events in the order of execution.
  const sortedLogEvents = useMemo(() => {
    var _ref;
    return (_ref = [...logEvents]) === null || _ref === void 0 ? void 0 : _ref.sort((aLogEvent, bLogEvent) => {
      const aTimestamp = aLogEvent.timestamp || 0;
      const bTimestamp = bLogEvent.timestamp || 0;
      return aTimestamp - bTimestamp;
    });
  }, [logEvents]);
  const {
    data: {
      [FLOW_BY_REVISION_TIMESTAMP_FIELD_NAME]: {
        flow: currentVersionFlow = null
      } = {}
    } = {},
    loading: isFlowLoading,
    error: flowError
  } = useQuery(GET_FLOW_BY_REVISION_TIMESTAMP, {
    variables: {
      flowId,
      revisionTimestamp: sortedLogEvents === null || sortedLogEvents === void 0 || (_sortedLogEvents$ = sortedLogEvents[0]) === null || _sortedLogEvents$ === void 0 ? void 0 : _sortedLogEvents$.timestamp
    },
    skip: !sortedLogEvents.length
  });
  return {
    loading: areLogEventsLoading || isFlowLoading,
    sortedLogEvents,
    refetchLogEvents,
    currentVersionFlow,
    error: logEventsError || flowError,
    startPolling,
    stopPolling
  };
};